import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'

export const parsePresearchFiltersNewRemittance = (presearchFilters: TwinDictionary) => {
    if(presearchFilters['to'] || presearchFilters['from']){
        presearchFilters['PayMCopyDate.date'] = { '$and': { ...(presearchFilters['to'] || {}), ...(presearchFilters['from'] || {}) } }
    }
    delete presearchFilters['from']
    delete presearchFilters['to']
    return presearchFilters
}